import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { DownIcon } from 'foundations-assets/icons/components/DownIcon';
import { UpIcon } from 'foundations-assets/icons/components/UpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ToggleMediaTimelineButton = props => {
  const {
    isMediaTimelineExpanded,
    handleToggleMediaTimeline
  } = props;
  return /*#__PURE__*/_jsxs(Button, {
    "data-test-id": "mediaTimeline-participantList-collapseBtn",
    use: "transparent",
    onClick: handleToggleMediaTimeline,
    marginBlockStart: "200",
    children: [isMediaTimelineExpanded ? /*#__PURE__*/_jsx(UpIcon, {
      color: "icon-core-subtle"
    }) : /*#__PURE__*/_jsx(DownIcon, {
      color: "icon-core-subtle"
    }), isMediaTimelineExpanded ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "recordingReviewComponents.media.mediaTimeline.hideBtn"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "recordingReviewComponents.media.mediaTimeline.showBtn"
    })]
  });
};
export default ToggleMediaTimelineButton;